function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { folderSpaceAddApi, folderSpaceEntTransferApi, folderSpaceRenameApi, folderSpaceShareEditApi, folderSpaceShareRuleApi } from '@/api/cloud';
export default {
  name: 'SpaceDialog',
  components: {
    selectMember: function selectMember() {
      return import('@/components/form-common/select-member');
    }
  },
  props: {
    fromData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      lookCheck: true,
      downloadCheck: false,
      editCheck: false,
      createCheck: false,
      deleteCheck: false,
      dialogData: [],
      userList: [],
      name: '',
      spaceButton: false,
      onlyPerson: false,
      openType: 1,
      transferUser: [],
      where: {
        page: 1,
        limit: 15
      }
    };
  },
  watch: {
    fromData: {
      handler: function handler(nVal) {
        if (nVal.edit === 2) {
          this.name = nVal.data.name;
          this.spaceButton = nVal.data.uid === this.$store.state.user.userInfo.uid;
          this.getFolderShareRule(nVal.data.id);
        }
      },
      deep: true
    }
  },
  methods: {
    handleClose: function handleClose() {
      this.userList = [];
      this.resetCheck();
      this.dialogVisible = false;
    },
    // 选择成员完成回调
    getSelectList: function getSelectList(data, type) {
      var _this = this;
      if (type === 1) {
        this.userList = data;
        this.shareArray = [];
        if (this.userList.length > 0) {
          this.userList.map(function (value) {
            if (value.isCheck) {
              _this.$set(value, 'lookCheck', true);
              _this.$set(value, 'createCheck', false);
              _this.$set(value, 'downloadCheck', false);
              _this.$set(value, 'editCheck', false);
              _this.$set(value, 'deleteCheck', false);
            }
          });
        }
      } else {
        this.transferUser = data;
        if (this.transferUser.length > 0) {
          var _data = {
            to_uid: this.transferUser[0].uid
          };
          this.setTransfer(this.fromData.data.id, _data);
        }
      }
      this.openStatus = false;
    },
    // 打开选择部门成员
    openDepartment: function openDepartment(type) {
      var that = this;
      if (type == 1) {
        that.$refs.selectMember.handlePopoverShow();
      } else {
        that.$refs.member[0].handlePopoverShow();
      }
    },
    handleAdd: function handleAdd() {
      if (this.name == '') {
        this.$message.error(this.$t('file.placeholder03'));
      } else {
        var list = [];
        var data = {};
        this.userList.forEach(function (value) {
          list.push({
            value: value.value,
            uid: value.uid,
            read: value.lookCheck ? 1 : 0,
            create: value.createCheck ? 1 : 0,
            download: value.downloadCheck ? 1 : 0,
            update: value.editCheck ? 1 : 0,
            delete: value.deleteCheck ? 1 : 0
          });
        });
        data = {
          name: this.name,
          rule: list
        };
        if (this.fromData.edit === 1) {
          this.getFolderShare(data);
        } else {
          data.folder = 1;
          this.getFolderRenameEdit(this.fromData.data.id, data);
        }
      }
    },
    handleChange: function handleChange(type) {
      if (type === 1) {
        this.lookCheck ? this.checkAll('lookCheck') : this.checkNone('lookCheck');
      } else if (type === 2) {
        this.createCheck ? this.checkAll('createCheck') : this.checkNone('createCheck');
      } else if (type === 3) {
        this.editCheck ? this.checkAll('editCheck') : this.checkNone('editCheck');
      } else if (type === 4) {
        this.downloadCheck ? this.checkAll('downloadCheck') : this.checkNone('downloadCheck');
      } else {
        this.deleteCheck ? this.checkAll('deleteCheck') : this.checkNone('deleteCheck');
      }
    },
    // 全选
    checkAll: function checkAll(items) {
      var _this2 = this;
      this.userList.forEach(function (item, index) {
        if (_this2.fromData.edit === 2 && item.id === _this2.$store.state.user.userInfo.uid) {} else {
          item[items] = true;
        }
      });
    },
    // 反选
    checkNone: function checkNone(items) {
      var _this3 = this;
      this.userList.forEach(function (item) {
        if (_this3.fromData.edit === 2 && item.id === _this3.$store.state.user.userInfo.uid) {} else {
          item[items] = false;
        }
      });
    },
    resetCheck: function resetCheck() {
      this.lookCheck = false;
      this.downloadCheck = false;
      this.editCheck = false;
      this.createCheck = false;
      this.deleteCheck = false;
      this.name = '';
    },
    deleteShare: function deleteShare(index) {
      this.userList.splice(index, 1);
      if (this.userList.length <= 0) {
        this.resetCheck();
      }
    },
    // 添加
    getFolderShare: function getFolderShare(data) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return folderSpaceAddApi(data);
            case 2:
              _context.next = 4;
              return _this4.handleClose();
            case 4:
              _this4.$emit('isOk');
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 修改
    getFolderRename: function getFolderRename(id, data) {
      var _this5 = this;
      folderSpaceRenameApi(id, data).then(function (res) {
        _this5.handleClose();
        _this5.$emit('isOk');
      });
    },
    getFolderRenameEdit: function getFolderRenameEdit(id, data) {
      var _this6 = this;
      folderSpaceShareEditApi(id, data).then(function (res) {
        if (res.status == 200) {
          _this6.handleClose();
          _this6.$emit('isOk');
        }
      });
    },
    // 转让空间
    setTransfer: function setTransfer(id, data) {
      var _this7 = this;
      folderSpaceEntTransferApi(id, data).then(function (res) {
        if (res.status == 200) {
          _this7.handleClose();
          _this7.$emit('isOk');
        }
      });
    },
    // 权限列表
    getFolderShareRule: function getFolderShareRule(id) {
      var _this8 = this;
      var data = {
        page: this.where.page,
        limit: this.where.limit
      };
      folderSpaceShareRuleApi(id, data).then(function (res) {
        _this8.userList = [];
        if (res.data.list.length > 0) {
          res.data.list.forEach(function (value) {
            if (value.to_uid !== _this8.fromData.data.uid) {
              var _data2 = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
                card: value.user,
                id: value.to_uid,
                uid: value.user.uid
              }, "id", value.user.id), "isCheck", false), "name", value.user.name), "value", value.user.id || 0), "lookCheck", value.auth.read === 1), "createCheck", value.auth.create === 1), "downloadCheck", value.auth.download === 1), "editCheck", value.auth.update === 1), "deleteCheck", value.auth.delete === 1);
              value.auth.read === 1 ? _this8.createCheck = true : _this8.createCheck = false;
              value.auth.download === 1 ? _this8.downloadCheck = true : _this8.downloadCheck = false;
              value.auth.update === 1 ? _this8.editCheck = true : _this8.editCheck = false;
              value.auth.delete === 1 ? _this8.deleteCheck = true : _this8.deleteCheck = false;
              _this8.userList.push(_data2);
            }
          });
        }
        // 生成第一个为管理的数据
        var card_id = JSON.parse(localStorage.getItem('userInfo'));
        var m = {
          card: _this8.fromData.data.user,
          isDelete: true,
          id: _this8.fromData.data.user.uid,
          uid: _this8.fromData.data.user.uid,
          value: card_id.id,
          isCheck: false,
          lookCheck: true,
          createCheck: true,
          downloadCheck: true,
          editCheck: true,
          deleteCheck: true
        };
        _this8.userList.unshift(m);
      });
    }
  }
};